// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1d40G","selects":"Documents_selects__zaQXy"};